import { Box, styled } from '@mui/material';
import { PageContentHeading } from 'shared/components';

interface ProfileHeadingProps {
    actions?: React.ReactNode;
    title?: string;
    subtitle?: string;
}

export default function ProfileHeading(props: ProfileHeadingProps) {
    return (
        <Root>
            <HeadingStyled { ...props } />
        </Root>
    );
}

const Root = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6, 6, 0, 6)
}));

const HeadingStyled = styled(PageContentHeading)(({ theme }) => ({
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    margin: '0 auto',
    padding: 0
}));
